<!-- eslint-disable max-len -->
<template>
  <datepicker
    v-model='value'
    @selected=setValue
    input-class="form-control bg-white"
    :bootstrap-styling="true"
    :format="'MMMM yyyy'"
    :initialView="'month'"
    :minimumView="'month'"
    :maximumView="'year'"
    :use-utc="false"
    :typeable="true"
  />
</template>

<script>
import { abstractField } from 'vue-form-generator';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'CustomMonthPicker',
  mixins: [abstractField],
  components: {
    Datepicker,
  },
  methods: {
    setValue(selectedDate) {
      this.value = selectedDate;
    },
  },
};
</script>
